import React from 'react';
import { WrappedFieldProps } from 'redux-form';

interface IOption {
  id: string;
  text: string;
  value: string;
}

interface IFormCheckboxProps {
  options: IOption[];
  line: boolean;
}

export default function FormCheckbox(
  props: WrappedFieldProps & IFormCheckboxProps,
) {
  const {
    input,
    options,
    meta: { touched, error },
    line,
  } = props;

  return (
    <>
      {options.map((option: IOption, index) => (
        <label
          key={option.id}
          htmlFor={option.id}
          className={`custom-check custom-check__radio mb1${
            line && index > 0 ? ' ml20' : ''
          }`}
        >
          <div className="custom-check--container">
            <input
              {...input}
              id={option.id}
              type="radio"
              value={option.value}
            />
            <div className="custom-check--bg" />
            <i />
          </div>
          <span>{option.text}</span>
        </label>
      ))}
      {touched && error && <small className="invalid">{error}</small>}
    </>
  );
}
